export default __webpack_public_path__ + "static/media/apple-touch-icon.19590b09.png";